import React, { useEffect, useState } from 'react';
import Header from '../Header/Header';
import axios from 'axios';
import { FaArrowRight } from 'react-icons/fa';
import { GoDotFill } from "react-icons/go";

const Account = () => {


    const [activeSection, setActiveSection] = useState('Profile Details');
    const [userData, setUserData] = useState(null);
    const userDataa = JSON.parse(sessionStorage.getItem('userData'));
    const userId = userDataa?.id;
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState({});
    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const response = await axios.get(`https://api.glocart.in/auth/api/api/user/${userId}/details`);
                setUserData(response.data.user);
            } catch (err) {
                console.log('Failed to load user details');
            }
        };
        fetchUserDetails();
    }, [userId]);
    const startEditing = () => {
        setEditData({
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            email: userData.email || '',
            mobile: userData.mobile || '',
            business_type: userData.business_type || '',
        });
        setIsEditing(true);
    };
    const cancelEditing = () => {
        setIsEditing(false);
        setEditData({});
    };
    const saveChanges = async () => {
        try {
            const response = await axios.put(`https://api.glocart.in/auth/api/api/user/${userId}/edit`,
                editData
            );
            if (response.data.success) {
                setUserData(response.data.user);
                setIsEditing(false);
            } else {
                console.error('Update failed');
            }
        } catch (err) {
            console.error('Error updating profile:', err);
        }
    };

    const handleChange = (e) => {
        setEditData({
            ...editData,
            [e.target.name]: e.target.value,
        });
    };
    const [isEditingAddress, setIsEditingAddress] = useState(false);
    const [editAddress, setEditAddress] = useState({
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: ''
    });


    const [isAddingAddress, setIsAddingAddress] = useState(false);
    const [newAddress, setNewAddress] = useState({
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip: ''
    });


    const sectionContent = {
        'Edit Profile': (
            <>
                <h4><strong>PROFILE DETAILS{' '}<span style={{ fontSize: '14px', color: '#007bff', cursor: 'pointer' }} onClick={() => !isEditing && startEditing()}>({isEditing ? 'Editing' : 'Edit'})</span></strong></h4>
                <hr />
                {userData && !isEditing && (
                    <>
                        <div style={{ border: '1px solid #ddd', padding: '16px', backgroundColor: '#f9f9f9', margin: '20px auto', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)' }}>
                            <p><FaArrowRight /> <strong>{userData.first_name} {userData.last_name}</strong></p>
                            <hr />
                            <p><GoDotFill /> {userData.email}</p>
                            <p><GoDotFill /> {userData.mobile}</p>
                            <p><GoDotFill /> {userData.business_type}</p>
                        </div>
                    </>
                )}
                {isEditing && (
                    <form onSubmit={e => { e.preventDefault(); saveChanges(); }}>
                        <div style={{ marginBottom: '10px' }}><label>First Name: </label><input type="text" name="first_name" value={editData.first_name} onChange={handleChange} required style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>Last Name: </label><input type="text" name="last_name" value={editData.last_name} onChange={handleChange} required style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>Email: </label><input type="email" name="email" value={editData.email} onChange={handleChange} required style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>Mobile: </label><input type="text" name="mobile" value={editData.mobile} onChange={handleChange} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>Business Type: </label><input type="text" name="business_type" value={editData.business_type} onChange={handleChange} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <button type="submit" style={{ marginRight: '10px' }}>Save</button>
                        <button type="button" onClick={cancelEditing}>Cancel</button>
                    </form>
                )}
            </>
        ),
        'Delivery Addresses': (
            <>
                <h4><strong>DELIVERY ADDRESSES</strong></h4>
                <hr />
                <div style={{ display: 'flex', gap: '20px', marginBottom: '10px' }}>
                    <button onClick={() => {
                        setNewAddress({
                            line1: '',
                            line2: '',
                            city: '',
                            state: '',
                            zip: ''
                        });
                        setIsAddingAddress(!isAddingAddress);
                        setIsEditingAddress(false); // close edit form if open
                    }}>{isAddingAddress ? 'Cancel Add' : 'Add New Address'}</button>
                </div>

                <hr />
                <p>Manage your saved delivery addresses.</p>
                {userData && userData.addresses && userData.addresses.length > 0 && !isEditingAddress && (
                    userData.addresses.map((address, index) => (
                        <div key={address.id || index} style={{ border: '1px solid #ddd', padding: '16px', backgroundColor: '#f9f9f9', margin: '20px auto', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)' }}>
                            <h3 style={{ fontSize: '1.2em', marginBottom: '12px', display: 'flex', alignItems: 'center', color: '#333' }}>
                                {userData.first_name} {userData.last_name} - Address {index + 1}

                                <button onClick={() => {
                                    if (!isEditingAddress && userData?.addresses?.[index]) {
                                        const addr = userData.addresses[index];
                                        setEditAddress({
                                            id: addr.id,  // Add this line to capture address ID
                                            line1: addr.line1 || '',
                                            line2: addr.line2 || '',
                                            city: addr.city || '',
                                            state: addr.state || '',
                                            zip: addr.zip || ''
                                        });
                                    }
                                    setIsEditingAddress(!isEditingAddress);
                                    setIsAddingAddress(false);
                                }}
                                    style={{ marginLeft: 'auto', padding: '6px 12px', fontSize: '14px', backgroundColor: isEditingAddress ? '#dc3545' : '#007bff', color: '#fff', border: 'none', cursor: 'pointer', transition: 'background-color 0.2s ease', }}>
                                    {isEditingAddress ? 'Cancel Edit' : 'Edit Address'}
                                </button>
                            </h3>
                            <hr />
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                <li><strong>Address:</strong> {address.line1}</li>
                                <li><strong>Address (optional):</strong> {address.line2}</li>
                                <li><strong>City:</strong> {address.city}</li>
                                <li><strong>State:</strong> {address.state}</li>
                                <li><strong>ZIP:</strong> {address.zip}</li>
                            </ul>
                        </div>
                    ))
                )}
                {isEditingAddress && (
                    <form onSubmit={async (e) => {
                        e.preventDefault();
                        try {
                            const res = await axios.put(
                                `https://api.glocart.in/auth/api/api/user/${userId}/address/edit/${editAddress.id}`,
                                {
                                    line1: editAddress.line1,
                                    line2: editAddress.line2,
                                    city: editAddress.city,
                                    state: editAddress.state,
                                    zip: editAddress.zip
                                }
                            );

                            if (res.data.success) {
                                // Update only the edited address in userData.addresses
                                setUserData((prev) => {
                                    const updatedAddresses = prev.addresses.map(addr =>
                                        addr.id === editAddress.id ? res.data.address : addr
                                    );
                                    return { ...prev, addresses: updatedAddresses };
                                });

                                setIsEditingAddress(false);
                            }
                        } catch (err) {
                            console.error("Address update failed:", err);
                        }
                    }}>

                        <div style={{ marginBottom: '10px' }}><label>Line 1: </label><input type="text" name="line1" value={editAddress.line1} onChange={e => setEditAddress({ ...editAddress, line1: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>Line 2: </label><input type="text" name="line2" value={editAddress.line2} onChange={e => setEditAddress({ ...editAddress, line2: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>City: </label><input type="text" name="city" value={editAddress.city} onChange={e => setEditAddress({ ...editAddress, city: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>State: </label><input type="text" name="state" value={editAddress.state} onChange={e => setEditAddress({ ...editAddress, state: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>ZIP: </label><input type="text" name="zip" value={editAddress.zip} onChange={e => setEditAddress({ ...editAddress, zip: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <button type="submit" style={{ marginRight: '10px' }}>Save</button>
                        <button type="button" onClick={() => setIsEditingAddress(false)}>Cancel</button>
                    </form>
                )}
                {isAddingAddress && (
                    <form onSubmit={async (e) => {
                        e.preventDefault();
                        try {
                            const res = await axios.post(`https://api.glocart.in/auth/api/api/user/${userId}/address/add`, newAddress);
                            if (res.data.success) {
                                setUserData(prev => ({
                                    ...prev,
                                    addresses: [...(prev.addresses || []), res.data.address]
                                }));
                                setIsAddingAddress(false);
                            }
                        } catch (err) {
                            console.error("Add address failed:", err);
                        }
                    }}>
                        <div style={{ marginBottom: '10px' }}><label>Line 1: </label><input type="text" name="line1" value={newAddress.line1} onChange={e => setNewAddress({ ...newAddress, line1: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>Line 2: </label><input type="text" name="line2" value={newAddress.line2} onChange={e => setNewAddress({ ...newAddress, line2: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>City: </label><input type="text" name="city" value={newAddress.city} onChange={e => setNewAddress({ ...newAddress, city: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>State: </label><input type="text" name="state" value={newAddress.state} onChange={e => setNewAddress({ ...newAddress, state: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <div style={{ marginBottom: '10px' }}><label>ZIP: </label><input type="text" name="zip" value={newAddress.zip} onChange={e => setNewAddress({ ...newAddress, zip: e.target.value })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} /></div>
                        <button type="submit" style={{ marginRight: '10px' }}>Add Address</button>
                        <button type="button" onClick={() => setIsAddingAddress(false)}>Cancel</button>
                    </form>
                )}

            </>
        ),
        'Email Addresses': (
            <>
                <h4><strong>EMAIL ADDRESSES</strong></h4>
                <hr />
                <p>Manage your email preferences and alternate emails.</p>
                <p>You can add additional email addresses to your account. Once a new email address is validated, you can log in to your account with that address or your primary email address registered with your account. Your password remains same across all the email addresses.</p>
                <p>Please note that all the email communication is sent to your main email address specified on the account.</p>
            </>
        ),
        'Profile Details': (
            <>
                <h4><strong>PROFILE DETAILS{' '}<span style={{ fontSize: '14px', color: '#007bff', cursor: 'pointer' }} onClick={() => !isEditing && startEditing()}>({isEditing ? 'Editing' : 'Edit'})</span></strong></h4>
                <hr />
                {userData && !isEditing && (
                    <>
                        <p><FaArrowRight /> <strong>{userData.first_name} {userData.last_name}</strong></p>
                        <p><GoDotFill /> {userData.email}</p>
                        <p><GoDotFill /> {userData.mobile}</p>
                        <p><GoDotFill /> {userData.business_type}</p>
                    </>
                )}
                {isEditing && (
                    <form onSubmit={e => { e.preventDefault(); saveChanges(); }}>
                        <div style={{ marginBottom: '10px' }}>
                            <label>First Name: </label>
                            <input type="text" name="first_name" value={editData.first_name} onChange={handleChange} required style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <label>Last Name: </label>
                            <input type="text" name="last_name" value={editData.last_name} onChange={handleChange} required style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <label>Email: </label>
                            <input type="email" name="email" value={editData.email} onChange={handleChange} required style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <label>Mobile: </label>
                            <input type="text" name="mobile" value={editData.mobile} onChange={handleChange} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} />
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <label>Business Type: </label>
                            <input type="text" name="business_type" value={editData.business_type} onChange={handleChange} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', border: '1px solid #ddd', marginBottom: '10px', cursor: 'pointer' }} />
                        </div>
                        <button type="submit" style={{ marginRight: '10px' }}>Save</button>
                        <button type="button" onClick={cancelEditing}>Cancel</button>
                    </form>
                )}
            </>
        ),
    };

    const menuItems = {
        'PERSONAL DETAILS': ['Edit Profile', 'Delivery Addresses', 'Email Addresses'],
    };

    // return (
    //     <>
    //         <Header />
    //         <div style={{ display: 'flex', justifyContent: 'center', padding: '20px', backgroundColor: '#f8f8f8', minHeight: '100vh', }}>
    //             <div style={{ display: 'flex', maxWidth: '1200px', width: '100%', backgroundColor: '#fff', boxShadow: '0 0 5px rgba(0,0,0,0.1)', }}>
    //                 <div style={{ width: '25%', padding: '20px', borderRight: '1px solid #e0e0e0', }}>
    //                     {Object.entries(menuItems).map(([sectionTitle, items]) => (
    //                         <div key={sectionTitle} style={{ marginBottom: '30px' }}>
    //                             <h4 style={{ fontSize: '14px', color: '#555', marginBottom: '10px', borderBottom: '1px solid #dcdcdc', paddingBottom: '5px' }}>{sectionTitle}</h4>
    //                             <ul style={{ listStyle: 'none', padding: 0 }}>
    //                                 {items.map((item) => (
    //                                     <li key={item} style={{ padding: '6px 0', cursor: 'pointer', color: activeSection === item ? '#007bff' : '#000', fontWeight: activeSection === item ? 'bold' : 'normal' }} onClick={() => setActiveSection(item)}>
    //                                         {item}
    //                                     </li>
    //                                 ))}
    //                             </ul>
    //                         </div>
    //                     ))}
    //                 </div>
    //                 <div style={{ width: '75%', padding: '30px' }}>{sectionContent[activeSection] || <p>Select a section from the left menu.</p>}</div>
    //             </div>
    //         </div>
    //     </>
    // );

    return (
        <>
            <Header />
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '40px 20px',
                backgroundColor: '#f0f2f5',
                minHeight: '100vh'
            }}>
                <div style={{
                    display: 'flex',
                    maxWidth: '1200px',
                    width: '100%',
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    boxShadow: '0 12px 28px rgba(0,0,0,0.1)',
                    overflow: 'hidden'
                }}>
                    {/* Sidebar */}
                    <div style={{
                        width: '25%',
                        padding: '30px 20px',
                        backgroundColor: '#f8f9fa',
                        borderRight: '1px solid #e0e0e0'
                    }}>
                        {Object.entries(menuItems).map(([sectionTitle, items]) => (
                            <div key={sectionTitle} style={{ marginBottom: '40px' }}>
                                <h4 style={{
                                    fontSize: '13px',
                                    color: '#6c757d',
                                    marginBottom: '15px',
                                    borderBottom: '1px solid #dcdcdc',
                                    paddingBottom: '6px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.7px'
                                }}>{sectionTitle}</h4>
                                <ul style={{ listStyle: 'none', padding: 0 }}>
                                    {items.map((item) => (
                                        <li key={item}
                                            style={{
                                                padding: '10px 12px',
                                                cursor: 'pointer',
                                                color: activeSection === item ? '#007bff' : '#495057',
                                                fontWeight: activeSection === item ? '600' : '400',
                                                borderRadius: '6px',
                                                marginBottom: '4px',
                                                backgroundColor: activeSection === item ? '#e7f1ff' : 'transparent',
                                                transition: 'all 0.2s'
                                            }}
                                            onClick={() => setActiveSection(item)}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    {/* Content */}
                    <div style={{
                        width: '75%',
                        padding: '40px 50px',
                        backgroundColor: '#fff'
                    }}>
                        {sectionContent[activeSection] || <p style={{ color: '#6c757d' }}>Select a section from the left menu.</p>}
                    </div>
                </div>
            </div>
        </>
    );


};

export default Account;
